import { useEffect, useRef } from 'react';
import { trackScrollDepth, trackPerformance } from '../utils/analytics';

export const useScrollTracking = () => {
  const lastTrackedDepth = useRef(0);
  const startTime = useRef(Date.now());

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollDepth = Math.round((scrollTop / scrollHeight) * 100);

      // Track scroll depth at 25%, 50%, 75%, 100%
      if (scrollDepth >= 25 && lastTrackedDepth.current < 25) {
        trackScrollDepth(25);
        lastTrackedDepth.current = 25;
      } else if (scrollDepth >= 50 && lastTrackedDepth.current < 50) {
        trackScrollDepth(50);
        lastTrackedDepth.current = 50;
      } else if (scrollDepth >= 75 && lastTrackedDepth.current < 75) {
        trackScrollDepth(75);
        lastTrackedDepth.current = 75;
      } else if (scrollDepth >= 100 && lastTrackedDepth.current < 100) {
        trackScrollDepth(100);
        lastTrackedDepth.current = 100;
      }
    };

    // Track initial page load performance
    const trackInitialLoad = () => {
      const loadTime = Date.now() - startTime.current;
      trackPerformance('initial_load_time', loadTime);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('load', trackInitialLoad);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('load', trackInitialLoad);
    };
  }, []);
}; 